import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { from, Observable } from 'rxjs';
import { UserauthenticationserviceService } from '../services/userauthenticationservice.service';
import { environment } from 'src/environments/environment';
import { ToastrService } from 'ngx-toastr';
import { LanguageService } from '../services/language.service';
import { EncryptDecryptService } from '../services/encrypt-decrypt.service';
import { EncryptMode } from '../services/questionservice.service';
import { ProctoringService } from '../services/proctoring.service';

declare const SafeExamBrowser;

@Injectable()
export class JwtInterceptor implements HttpInterceptor {

  constructor(private useraccessservice: UserauthenticationserviceService, private toastr: ToastrService,private languageService: LanguageService, private encryptdecryptservice: EncryptDecryptService) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const currentUserToken = this.useraccessservice.getCurrentUserToken();
    const currentUserSEBKey = this.useraccessservice.getSEBKey();
   
    const isLoggedIn = currentUserToken != null;
    const sebVersion = typeof SafeExamBrowser !== 'undefined' ? SafeExamBrowser?.version : '';
    const platform = ((navigator as any).userAgentData?.platform ?? navigator.platform);
    const macAddress = typeof SafeExamBrowser !== 'undefined' ? SafeExamBrowser?.security?.macAddress ?? '' : '';

    const processHeaders = async () => {
    if (isLoggedIn && (request.url.startsWith(environment.CBTAPIURL) || request.url.startsWith(environment.CBTS3APIURL))) {
        request = request.clone({
          setHeaders: {
            Authorization: `Bearer ${currentUserToken}`,
            seb: await this.encryptdecryptservice.decryptEncrpyt(JSON.stringify({currentUserSEBKey, platform, sebVersion, url: window.location.href, macAddress: macAddress}), EncryptMode.e),
            languageCode:this.languageService.getLanguageCode()
          }
        });
      }
      return next.handle(request).toPromise();
    }

    return from(processHeaders());
  }

  
}
